import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const BCNEXT_URL = "https://www.bcnext.it/";
export const BCNEXT_LOGO = "/bcnext-logo.png";

export const BcNextStrip = () => (
  <section
    className="mx-auto max-w-[1400px] px-5 pb-16 sm:px-10 sm:pb-20"
    data-testid="bcnext-strip"
    aria-label="Partner tecnologico BC Next"
  >
    <motion.div
      initial={{ opacity: 0, y: 22 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6 }}
      className="flex flex-wrap items-center justify-between gap-6 rounded-[26px] border border-[#E8E2E4] bg-white p-7 shadow-[0_8px_32px_rgba(94,42,82,0.06)] sm:p-9"
    >
      <div className="flex items-center gap-5">
        <img
          src={BCNEXT_LOGO}
          alt="Logo BC Next"
          data-testid="bcnext-logo"
          className="h-14 w-14 rounded-xl bg-[#0E1116] object-contain p-2"
          loading="lazy"
        />
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-[#6B5E62]">
            Partner tecnologico
          </p>
          <p className="mt-1 font-display text-2xl text-[#1A1617]">
            Progettato e sviluppato da BC NEXT
          </p>
          <p className="mt-1 text-sm text-[#6B5E62]">
            Consulenza IT &amp; sviluppo software — “Il software, fatto bene.”
          </p>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <Link
          to="/partner"
          data-testid="bcnext-strip-cta"
          className="rounded-full bg-[#5E2A52] px-6 py-3 text-sm font-semibold text-white transition-colors duration-300 hover:bg-[#E0708A]"
        >
          La partnership
        </Link>
        <a
          href={BCNEXT_URL}
          target="_blank"
          rel="noreferrer"
          data-testid="bcnext-strip-site"
          className="inline-flex items-center gap-1.5 rounded-full border border-[#E8E2E4] px-6 py-3 text-sm font-semibold text-[#5E2A52] transition-colors duration-300 hover:border-[#E0708A] hover:text-[#E0708A]"
        >
          bcnext.it <ArrowUpRight size={15} />
        </a>
      </div>
    </motion.div>
  </section>
);
